<div class="search-redesign-container" [class.search-redesign-disabled]="disabled" [style.maxWidth]="largura">
  <img [src]="icone" alt="" class="search-redesign-icone" />
  <input
    type="text"
    class="search-redesign-input"
    [placeholder]="placeholder"
    [value]="valor"
    [disabled]="disabled"
    (input)="aoDigitar($any($event.target).value)"
  />
</div>
